/* RESPONSIBLE TEAM: team-phone */
import Step from 'embercom/models/operator/visual-builder/step';
import type Store from '@ember-data/store';
import { buildValidations } from 'ember-cp-validations';
import { SUPPORTED_CHANNELS } from 'embercom/lib/operator/custom-bots/constants-2';
import type ConnectionPoint from '../connection-point';

const Validations = buildValidations({});

export default class PhoneOneTimePasscode extends Step.extend(Validations) {
  get supportedChannels() {
    return SUPPORTED_CHANNELS.phoneOneTimePasscode;
  }

  static get isStepGroupEnding() {
    return false;
  }

  static createNewStep(store: Store): PhoneOneTimePasscode {
    let outwardConnectionPoints = [
      store.createRecord('operator/visual-builder/connection-point', {
        type: 'fallback',
      }),
    ] as ConnectionPoint[];

    return store.createRecord('operator/visual-builder/step/phone-one-time-passcode', {
      outwardConnectionPoints,
      type: 'operator/visual-builder/step/phone-one-time-passcode',
    });
  }
}
